// ─── ADD TRANSACTION TYPE-PICKER PANEL ───────────────────────────────────────

// ─── Icons ────────────────────────────────────────────────────────────────────
const PrintIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
    </svg>
);
const ChevronDown = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
);
const ChevronLeft = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
);
const SearchIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0" />
    </svg>
);
const XIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);
const PlusIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
);




export const AddTransactionPanel = ({ isOpen, onClose, transactionTypes, bankName, onSelect }) => (
    <>
        <div
            className={`fixed top-0 right-0 h-screen w-80 bg-white z-40 flex flex-col overflow-hidden
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
            style={{ borderLeft: '1px solid #e5e7eb', boxShadow: '-4px 0 24px rgba(0,0,0,0.08)' }}
        >
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 bg-gray-50">
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-0.5">New Transaction</p>
                    <h3 className="text-base font-bold text-gray-800">Select Type</h3>
                </div>
                <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:bg-gray-200 hover:text-gray-700 transition">
                    <XIcon />
                </button>
            </div>

            <div className="px-5 pt-4 pb-2">
                <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
                    <span className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
                    <span className="text-xs text-blue-700 font-medium">
                        From: <span className="font-bold">{bankName || 'Selected Account'}</span>
                    </span>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
                {/* MONEY OUT SECTION */}
                <div>
                    <div className="px-2 mb-2">
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">MONEY OUT</p>
                        <div className="h-px bg-gray-100 w-full mt-1" />
                    </div>
                    <div className="space-y-1">
                        {transactionTypes?.filter(t => t.type === 'out').map((type, index) => (
                            <button
                                key={index}
                                onClick={() => onSelect(type)}
                                className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-left text-sm font-medium text-gray-700
                      hover:bg-red-50 hover:text-red-700 transition group border border-transparent hover:border-red-100"
                            >
                                <div className="flex items-center gap-3">

                                    <span>{type.display_name || type.transaction_name}</span>
                                </div>
                                <svg className="w-4 h-4 text-gray-300 group-hover:text-red-500 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        ))}
                    </div>
                </div>

                {/* MONEY IN SECTION */}
                <div>
                    <div className="px-2 mb-2">
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">MONEY IN</p>
                        <div className="h-px bg-gray-100 w-full mt-1" />
                    </div>
                    <div className="space-y-1">
                        {transactionTypes?.filter(t => t.type === 'in').map((type, index) => (
                            <button
                                key={index}
                                onClick={() => onSelect(type)}
                                className="w-full flex items-center justify-between px-4 py-3 rounded-lg text-left text-sm font-medium text-gray-700
                      hover:bg-green-50 hover:text-green-700 transition group border border-transparent hover:border-green-100"
                            >
                                <div className="flex items-center gap-3">

                                    <span>{type.display_name || type.transaction_name}</span>
                                </div>
                                <svg className="w-4 h-4 text-gray-300 group-hover:text-green-500 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        ))}
                    </div>
                </div>

                {(!transactionTypes || transactionTypes.length === 0) && (
                    <p className="text-sm text-gray-400 text-center py-8">No transaction types available.</p>
                )}
            </div>
        </div>
    </>
);